module.exports = __webpack_public_path__ + "img/9.442d5a43.jpeg";